import request from '@/tools/request';
import { MessageBox, Notification } from 'element-ui';
import rejectDialogCreator from '@/page/project-record/components/rejectDialogCreator';
import Vue from 'vue';

// 获得 任务记录列表
export const getList = {
  root: false,
  handler: async ({ state, commit, rootState }, params) => {
    return new Promise(resolve => {
      const {
        homeProject: { id: projectId, type, projectType }
      } = rootState;
      if (!projectId || !type || !projectType) return;

      const query = {
        ...state.tableSearchQuery,
        ...state.pageQuery,
        projectId,
        type,
        isSelected: 1,
        ...params
      };
      commit('SET_TABLE_LOADING', true);
      // 用户标签 字符串形式
      // if (query.userTag && Array.isArray(query.userTag)) {
      //   if (query.userTag.includes('未设置')) {
      //     query.notSet = 1;
      //   }
      //   query.userTag = query.userTag.join(',');
      // }
      query.notSet = query.userTag == '未设置' ? 1 : 0;
      request
        .post(
          // 'http://yapi.jimijiayuan.cn/mock/672/rest/crm/oss/taskRecord/taskRecordList',
          '/rest/cso/saas/taskRecord/taskRecordList',
          query
        )
        .then(res => {
          const {
            data: {
              data: { list, total, selectedSize, maxSelectedSize }
            }
          } = res;

          // 在返回数据中 加入 请求时的 一些参数 比如 type 字段，type在任务列表点击查看 详情接口 需要
          let result = list.map(i => {
            return {
              ...i,
              type: type
            };
          });
          commit('SET_TABLE_DATA', result);
          commit('SET_SELECTED_SIZE', selectedSize);
          commit('SET_MAX_SELECTED_SIZE', maxSelectedSize);
          commit('SET_PAGE_TOTAL', total);

          // 缓存结果 的搜索条件，用来做结果选择
          commit('SET_TABLE_DATARESPOND_QUERY', query);

          commit('SET_TABLE_LOADING', false);
          resolve({ list: result, total, selectedSize, query });

          commit('SET_TABLE_LOADING', false);
        });
    });
  }
};
// 结果全选，注意：接口要带选择搜索后的搜索条件
export const selectAll = {
  root: false,
  handler: async ({ state, rootState, dispatch }, isSelected) => {
    const {
      dataAnalysis: {
        projectDetail: { projectId, type }
      }
    } = rootState;
    const q = {
      ...state.pageQuery,
      projectId,
      type,
      ...state.tableDataRespondQuery,
      isSelected: isSelected ? 1 : 0
    };

    // 用户标签 字符串形式
    if (q.userTag && Array.isArray(q.userTag)) {
      if (q.userTag.includes('未设置')) {
        q.notSet = 1;
      }
      q.userTag = q.userTag.join(',');
    }

    const {
      data: { code }
    } = await request.post('/rest/cso/saas/taskRecord/taskRecordListAll', q, {
      serviceLoading: true
    });
    if (+code === 1) {
      return dispatch('getList', q);
    }
  }
};

// 批量审核 isPass 2:通过 3：不通过
export const batchAudit = {
  root: false,
  handler: async ({ state, rootState, commit }, auditStatus) => {
    return new Promise((resolve, reject) => {
      const {
        dataAnalysis: {
          projectDetail: { projectId }
        }
      } = rootState;

      const query = {
        projectId,
        auditStatus
      };

      // 审核 通过
      if (+auditStatus === 2) {
        MessageBox.confirm(
          `<p>是否确认通过 <span style='color:#027cfa'>${state.selectedSize}</span> 条任务记录，请谨慎操作</p>`,
          {
            dangerouslyUseHTMLString: true
          }
        )
          .then(() => {
            // 展示 loading
            const loading = Vue.prototype.$loading({
              lock: true,
              text: `0 / ${state.selectedSize}`,
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            // 轮询进度
            state.queryCountTimer = setInterval(async () => {
              const {
                data: { data }
              } = await request.post(
                '/rest/cso/saas/taskRecord/auditOssStatus/all/queryCount',
                {
                  projectId: projectId,
                  source: 1 //1任务记录 2 快捷审核
                }
              );
              loading.setText(`${data} / ${state.selectedSize}`);
            }, 500);
            request
              .post('/rest/cso/saas/taskRecord/auditOssStatus/all', query, {
                serviceLoading: true
              })
              .then(res => {
                const {
                  data: { code, data, message }
                } = res;
                if (+code === 1) {
                  Notification({
                    title: data,
                    message: message,
                    type: 'success'
                  });
                  resolve();
                } else {
                  Notification({
                    title: data,
                    message: message,
                    type: 'error'
                  });
                  reject();
                }
              })
              .finally(() => {
                loading.setText(
                  `${state.selectedSize} / ${state.selectedSize}`
                );
                commit('CLEAR_QUERY_COUNT_TIMER');
                loading.close();
              });
          })
          .catch(() => {
            reject();
            return;
          });
      }
      // 审核 不通过
      if (+auditStatus === 3) {
        rejectDialogCreator()
          .then(remark => {
            query.remark = remark;
            request
              .post('/rest/cso/saas/taskRecord/auditOssStatus/all', query, {
                serviceLoading: true
              })
              .then(res => {
                const {
                  data: { code, data, message }
                } = res;
                if (+code === 1) {
                  Notification({
                    title: data,
                    message: message,
                    type: 'success'
                  });
                  resolve();
                } else {
                  Notification({
                    title: data,
                    message: message,
                    type: 'error'
                  });
                }
              });
          })
          .catch(() => {});
      }
    });
  }
};

/**
 * @description: 单挑审核。列表与详情中共用。在快捷审核中单独处理：api地址更变，多了conditions参数
 * @param {number} 当前审核状态
 * @param {number} 当条记录ID
 * @param {number} 项目ID
 * @param {object} 快捷审核中的API与参数 {api,conditions}
 * @return {Promise}
 */
export const audit = {
  root: false,
  handler: async (
    { rootState, dispatch },
    {
      auditStatus,
      taskId,
      projectId,
      quickAudit = {
        api: '',
        conditions: {
          key: '',
          value: '',
          isTopic: '',
          topicType: ''
        }
      }
    }
  ) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      const {
        dataAnalysis: {
          projectDetail: { projectId: rootProjectId }
        }
      } = rootState;
      projectId = projectId || rootProjectId;
      const api = quickAudit.api || '/rest/cso/saas/taskRecord/auditOssStatus';
      const query = {
        projectId,
        auditStatus,
        taskId,
        ...quickAudit
      };
      try {
        // 审核 通过
        if (+auditStatus === 2) {
          await MessageBox.confirm('<p>是否确认通过 任务记录，请谨慎操作</p>', {
            dangerouslyUseHTMLString: true
          });
        }
        // 审核 不通过
        if (+auditStatus === 3) {
          try {
            query.remark = await rejectDialogCreator();
          } catch (err) {
            return;
          }
        }
      } catch (err) {
        return;
      }
      const {
        data: { code, data, message }
      } = await request.post(api, query);

      if (+code === 1) {
        Notification({
          title: data,
          message: message,
          type: 'success'
        });
        dispatch('getList', { isSelected: 0 });
        resolve();
      } else {
        Notification({
          title: data,
          message: message,
          type: 'error'
        });
        reject();
      }
    });
  }
};
